/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
// import dashboard from './dashboard'
import sideNavItems from './apps-and-pages'
import accounts from './accounts'
import admin from './admin'
import channels from './channels'
import eChannels from './e-channels'
import operations from './operations'
import postings from './postings'
import dataUploads from './data-uploads'
import fraudMonitor from './fraud-monitor'
import dataMigrations from './data-migrations'
import reports from './reports'
import dashboard from './dashboard'
import lMS from './lms'

// Array of sections
// export default [...sideNavItems]
export default [
  ...sideNavItems,
  ...dashboard,
  ...accounts,
  ...admin,
  ...channels,
  ...eChannels,
  ...operations,
  ...postings,
  ...dataUploads,
  ...fraudMonitor,
  ...dataMigrations,
  ...reports,
  ...lMS,
]
